import { ReactComponent as IconClose } from 'mrg-icons/src/mailru/actions/close.svg';
import PropTypes from 'prop-types';
import React, { cloneElement, createRef, PureComponent } from 'react';
import { Portal } from 'react-portal';
import { Tooltip } from 'reactApp/ui/Tooltip/Tooltip';
import { noop } from 'reactApp/utils/helpers';

import styles from './Bubble.css';

export class Bubble extends PureComponent {
    nodeRef = createRef();

    static propTypes = {
        children: PropTypes.node,
        title: PropTypes.string,
        text: PropTypes.node,
        icon: PropTypes.node,
        isOpen: PropTypes.bool,
        placement: PropTypes.string,
        target: PropTypes.node,
        onClose: PropTypes.func,
        smartPlacement: PropTypes.bool,
        noArrow: PropTypes.bool,
        closeOnOutsideClick: PropTypes.bool,
        fixed: PropTypes.bool,
    };

    static defaultProps = {
        isOpen: true,
        onClose: noop,
        smartPlacement: true,
        closeOnOutsideClick: true,
        fixed: false,
    };

    state = {
        isOpen: false,
    };

    componentDidMount() {
        if (this.props.isOpen && ((this.nodeRef && this.nodeRef.current) || this.props.target)) {
            this.setState({
                isOpen: true,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen && this.nodeRef && this.nodeRef.current) {
            this.setState({
                isOpen: this.props.isOpen,
            });
        }
    }

    handleOnClose = () => {
        this.setState({
            isOpen: false,
        });
        this.props.onClose();
    };

    render() {
        const { icon, text, title, children, placement, target, smartPlacement, noArrow, closeOnOutsideClick, fixed } = this.props;
        const { isOpen } = this.state;

        return (
            <>
                {!!children &&
                    cloneElement(children, {
                        ref: this.nodeRef,
                    })}
                <Portal>
                    {isOpen && (
                        <Tooltip
                            target={this.nodeRef.current ? this.nodeRef.current : target}
                            pinned
                            smartPlacement={smartPlacement}
                            placement={placement}
                            onClose={this.handleOnClose}
                            theme="octavius"
                            noArrow={noArrow}
                            closeOnOutsideClick={closeOnOutsideClick}
                            fixed={fixed}
                        >
                            <div className={styles.root}>
                                <div className={styles.close} onClick={this.handleOnClose}>
                                    <IconClose />
                                </div>
                                {icon && <div className={styles.icon}>{icon}</div>}
                                <div className={styles.content}>
                                    {!!title && <div className={styles.title}>{title}</div>}
                                    {!!text && <div className={styles.text}>{text}</div>}
                                </div>
                            </div>
                        </Tooltip>
                    )}
                </Portal>
            </>
        );
    }
}
